import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function PortalWrapper({ children }) {
    const [portalRoot, setPortalRoot] = useState(null);

    useEffect(() => {
        const node = document.getElementById('sim-options');
        if (node) setPortalRoot(node);
    }, []);

    if (!portalRoot) return null;

    return createPortal(children, portalRoot);
}